import { render } from "./ListarComprobantes.vue?vue&type=template&id=36ee520a&scoped=true"
import script from "./ListarComprobantes.vue?vue&type=script&lang=js"
export * from "./ListarComprobantes.vue?vue&type=script&lang=js"

import "./ListarComprobantes.vue?vue&type=style&index=0&id=36ee520a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ee520a"]])

export default __exports__